const CUSTOM_AMOUNT_VALIDATION_STATUS = {
  REGEX_ERROR: 'REGEX_ERROR',
  MAX_ERROR: 'MAX_ERROR',
  VALID: 'VALID',
};
export { CUSTOM_AMOUNT_VALIDATION_STATUS }; // eslint-disable-line import/prefer-default-export
